import {Component, OnInit, Input, Output, EventEmitter} from '@angular/core';
import {NavService} from '../../../../services/nav.service';
import {JourneyStageDetailsModel} from '../../models/journey-page.model';
import {fadeInOnEnterAnimation} from 'angular-animations';
import {JourneyService} from '../../service/journey.service';
import {MyDiaryUpdateRequestModel, ProgramDelegateModel, UserDiaryUpdateRequestModel} from '../../models/program.model';
import {AlertController} from '@ionic/angular';
import {EventsService} from '../../../../services/events.service';
import {AnalyticsService} from '../../../../services/analytics.service';
import {TranslateService} from '@ngx-translate/core';

@Component({
    selector: 'app-learning-journey-programm-template',
    templateUrl: './programm-template.component.html',
    styleUrls: ['./programm-template.component.scss'],
    animations: [fadeInOnEnterAnimation({anchor: 'enter', duration: 300})]
})
export class LearningJourneyProgrammTemplateComponent implements OnInit {

    @Input() stage: JourneyStageDetailsModel;
    @Input() programDelegate: ProgramDelegateModel;
    @Input() level: string;
    @Output() doChangeSaveButton: EventEmitter<any> = new EventEmitter();

    private _saveForm = false;
    @Input()
    set saveForm(value: boolean) {
        this._saveForm = value;
        if (value) {
            this.onSubmit();
        }
    }

    radioGroup = [
        {text: '1', value: '1', class: ''},
        {text: '2', value: '2', class: ''},
        {text: '3', value: '3', class: ''},
        {text: '4', value: '4', class: ''},
        {text: '5', value: '5', class: ''}
    ];

    constructor(
        private nav: NavService,
        private event: EventsService,
        private analytics: AnalyticsService,
        private alertController: AlertController,
        private translate: TranslateService,
        private journeyService: JourneyService
    ) {
    }

    ngOnInit() {
    }

    onChange(event) {
        this.event.publish('form:changed', 'journey:diary');
        this.doChangeSaveButton.emit(event);
    }

    onSubmit(): void {
        if (this.level === 'manager') {
            const model = new UserDiaryUpdateRequestModel();
            model.pr_del_id = this.programDelegate.id;
            model.man_obj = this.programDelegate.man_obj.value;
            model.man_act_outcomes = this.programDelegate.man_act_outcomes.value;

            this.journeyService.updateUserDiary(model)
                .then(responce => {
                    if (responce.status !== null) {
                        this.event.publish('form:saved', {name: 'userDiary', id: model.pr_del_id});
                        this.alertController.create({
                            header: this.translate.instant('__ALERT_SUCCESS_TITLE__'),
                            message: this.translate.instant(responce.message),
                            buttons: [{
                                text: this.translate.instant('__ALERT_SUCCESS_BUTTON__'),
                                handler: () => {
                                    setTimeout(() => {this.nav.back()});
                                }
                            }]
                        }).then(a => a.present());
                    }
                });
        }

        if (this.level === 'learner') {
            const model = new MyDiaryUpdateRequestModel();
            model.pr_del_id = this.programDelegate.id;
            model.del_obj = this.programDelegate.del_obj.value;
            model.del_act_outcomes = this.programDelegate.del_act_outcomes.value;
            model.feedback = this.programDelegate.feedback;

            this.journeyService.updateMyDiary(model)
                .then(responce => {
                    if (responce.status !== null) {
                        this.event.publish('form:saved', {name: 'myDiary', id: model.pr_del_id});
                        this.alertController.create({
                            header: this.translate.instant('__ALERT_SUCCESS_TITLE__'),
                            message: this.translate.instant(responce.message),
                            buttons: [this.translate.instant('__ALERT_SUCCESS_BUTTON__')]
                        }).then(a => a.present());
                    }
                });
        }
    }

    openFile(url) {
        this.nav.toLink(url);
    }

    changeAttendance(status) {
        if (this.level === 'learner') {
            this.journeyService.updateMyDiaryAttendance(this.programDelegate.id, status)
                .then(responce => {
                });
        }
    }
}
